var React = require('react');

function QuotesInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M51.15 53.16C59.32 53.16 65.78 46.89 65.78 39.1C65.78 30.74 59.51 24.66 51.53 24.66C52.67 19.72 56.85 12.5 64.07 6.23L58.37 0.719991C41.84 11.17 36.33 26.18 36.33 36.44C36.33 46.32 43.36 53.16 51.15 53.16ZM15.81 53.16C23.98 53.16 30.44 46.89 30.44 39.1C30.44 30.74 24.17 24.66 16.19 24.66C17.33 19.72 21.51 12.5 28.73 6.23L23.03 0.719991C6.5 11.17 0.99 26.18 0.99 36.44C0.99 46.32 8.02 53.16 15.81 53.16Z"}));
}

QuotesInline.defaultProps = {"width":"66","height":"54","viewBox":"0 0 66 54","fill":"none","className":"icon"};

module.exports = QuotesInline;

QuotesInline.default = QuotesInline;
